import Skeleton from "react-loading-skeleton";

const ProductSkelton = () => {
  return (
    <
      // style={{
      //   width: "100%",
      //   display: "grid",
      //   gap: "30px",
      //   gridTemplateColumns: "repeat(3, minmax(0, 1fr))",
      // }}
    >
      {Array.from({ length: 3 }, (_, index) => index).map((item) => (
        <div
          key={item}
          style={{
            display: "flex",
            flexDirection: "column",
            gap: "5px",
            justifyContent: "center",
            textAlign: "center",
            width: "100%",
          }}
        >
          <Skeleton style={{ height: "400px" }} />
          <Skeleton
            style={{ height: "20px", width: "100%", textAlign: "center" }}
          />
          <Skeleton count={1} style={{ width: "20%" }} />
        </div>
      ))}
    </>
  );
};
export default ProductSkelton;
